module.exports = __webpack_public_path__ + "img/github.4c6a4703.svg";